import { API_URL } from '../config/api';

// Log modülleri
export const LOG_MODULES = {
  AUTH: 'auth',
  SALES: 'sales',
  PRODUCTS: 'products',
  CUSTOMERS: 'customers',
  REPAIRS: 'repairs',
  CAMPAIGNS: 'campaigns',
  INVENTORY: 'inventory',
  PERSONNEL: 'personnel',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  SCRAP: 'scrap',
  EXPENSES: 'expenses',
  DEBTS: 'debts',
  TERMINAL: 'terminal',
  RATES: 'rates'
};

// Log aksiyonları
export const LOG_ACTIONS = {
  // Auth
  LOGIN: 'login',
  LOGOUT: 'logout',
  LOGIN_FAILED: 'login_failed',

  // CRUD
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',

  // Satış
  SALE_COMPLETE: 'sale_complete',
  SALE_CANCEL: 'sale_cancel',
  REFUND: 'refund',
  EXCHANGE: 'exchange',
  HOLD_SALE: 'hold_sale',
  RESUME_SALE: 'resume_sale',
  APPLY_DISCOUNT: 'apply_discount',
  APPLY_CAMPAIGN: 'apply_campaign',
  PRICE_CHANGE: 'price_change',

  // POS Detaylı Aksiyonlar (Fraud Detection)
  CART_ADD: 'cart_add',
  CART_REMOVE: 'cart_remove',
  CART_CLEAR: 'cart_clear',
  CART_QUANTITY_CHANGE: 'cart_quantity_change',
  CART_PRICE_EDIT: 'cart_price_edit',
  PAYMENT_START: 'payment_start',
  PAYMENT_CANCEL: 'payment_cancel',
  CUSTOMER_SELECT: 'customer_select',
  CUSTOMER_REMOVE: 'customer_remove',
  STAFF_SELECT: 'staff_select',
  SALE_EDIT: 'sale_edit',
  SALE_DELETE: 'sale_delete',
  GIFT_CARD_APPLY: 'gift_card_apply',
  GIFT_CARD_REMOVE: 'gift_card_remove',
  SCRAP_DISCOUNT_APPLY: 'scrap_discount_apply',
  PARTIAL_PAYMENT: 'partial_payment',
  DEBT_SALE: 'debt_sale',

  // Stok
  STOCK_IN: 'stock_in',
  STOCK_OUT: 'stock_out',
  STOCK_ADJUST: 'stock_adjust',
  INVENTORY_COUNT: 'inventory_count',

  // Müşteri
  DEBT_ADD: 'debt_add',
  DEBT_PAYMENT: 'debt_payment',

  // Tamir
  REPAIR_STATUS_CHANGE: 'repair_status_change',
  REPAIR_PAYMENT: 'repair_payment',

  // Diğer
  EXPORT: 'export',
  IMPORT: 'import',
  BACKUP: 'backup',
  RESTORE: 'restore',
  PRINT: 'print',
  EMAIL_SEND: 'email_send',
  VIEW: 'view',
  SEARCH: 'search',
  FILTER: 'filter'
};

// Entity tipleri
export const ENTITY_TYPES = {
  SALE: 'sale',
  PRODUCT: 'product',
  CUSTOMER: 'customer',
  REPAIR: 'repair',
  CAMPAIGN: 'campaign',
  USER: 'user',
  EMPLOYEE: 'employee',
  STORE: 'store',
  SCRAP: 'scrap',
  EXPENSE: 'expense',
  DEBT: 'debt',
  GIFT_CARD: 'gift_card',
  INVOICE: 'invoice'
};

// Log servisi
class LogService {
  constructor() {
    this.user = null;
    this.store = null;
  }

  // Kullanıcı ve mağaza bilgisini set et
  setContext(user, store) {
    this.user = user;
    this.store = store;
  }

  // Log kaydet
  async log(module, action, description, options = {}) {
    try {
      const {
        details = null,
        entity_type = null,
        entity_id = null,
        entity_code = null,
        status = 'info'
      } = options;

      const payload = {
        user_id: this.user?.id,
        user_name: this.user?.name,
        user_role: this.user?.role,
        store_id: this.store?.id,
        store_name: this.store?.name,
        module,
        action,
        description,
        details,
        entity_type,
        entity_id,
        entity_code,
        status
      };

      // Async olarak gönder, sonucu bekleme
      fetch(`${API_URL}/logs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(err => console.error('Log kaydedilemedi:', err));

    } catch (error) {
      console.error('Log hatası:', error);
    }
  }

  // Kısayol metodlar

  // Auth logları
  loginSuccess(user) {
    this.log(LOG_MODULES.AUTH, LOG_ACTIONS.LOGIN, `${user.name} giriş yaptı`, {
      entity_type: ENTITY_TYPES.USER,
      entity_id: user.id,
      status: 'success',
      details: { email: user.email, role: user.role }
    });
  }

  loginFailed(email, reason) {
    this.log(LOG_MODULES.AUTH, LOG_ACTIONS.LOGIN_FAILED, `Başarısız giriş denemesi: ${email}`, {
      status: 'warning',
      details: { email, reason }
    });
  }

  logout() {
    this.log(LOG_MODULES.AUTH, LOG_ACTIONS.LOGOUT, `${this.user?.name} çıkış yaptı`, {
      entity_type: ENTITY_TYPES.USER,
      entity_id: this.user?.id,
      status: 'info'
    });
  }

  // Satış logları
  saleComplete(sale, items, paymentMethod) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.SALE_COMPLETE,
      `Satış tamamlandı: ${sale.total.toFixed(2)} TL - ${items.length} ürün`, {
      entity_type: ENTITY_TYPES.SALE,
      entity_id: sale.id,
      status: 'success',
      details: {
        total: sale.total,
        discount: sale.discount,
        payment_method: paymentMethod,
        items_count: items.length,
        customer_id: sale.customer_id,
        items: items.map(i => ({ id: i.id, name: i.name, qty: i.quantity, price: i.price }))
      }
    });
  }

  refund(saleId, amount, items) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.REFUND,
      `İade yapıldı: ${amount.toFixed(2)} TL - Satış #${saleId}`, {
      entity_type: ENTITY_TYPES.SALE,
      entity_id: saleId,
      status: 'warning',
      details: { amount, items }
    });
  }

  exchange(saleId, returnItems, newItems) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.EXCHANGE,
      `Değişim yapıldı: Satış #${saleId}`, {
      entity_type: ENTITY_TYPES.SALE,
      entity_id: saleId,
      status: 'info',
      details: { returnItems, newItems }
    });
  }

  applyDiscount(amount, type) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.APPLY_DISCOUNT,
      `İndirim uygulandı: ${type === 'percent' ? '%' + amount : amount + ' TL'}`, {
      status: 'info',
      details: { amount, type }
    });
  }

  priceChange(productId, productName, oldPrice, newPrice) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.PRICE_CHANGE,
      `Fiyat değiştirildi: ${productName} - ${oldPrice} TL → ${newPrice} TL`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: productId,
      status: 'warning',
      details: { oldPrice, newPrice }
    });
  }

  // ===== POS DETAYLI LOGLAR (Fraud Detection) =====

  cartAdd(product, quantity, cartTotal) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.CART_ADD,
      `Sepete eklendi: ${product.name} x${quantity} - ${product.price || product.sell_price} TL`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: product.id,
      status: 'info',
      details: {
        product_id: product.id,
        product_name: product.name,
        barcode: product.barcode,
        quantity,
        price: product.price || product.sell_price,
        cart_total: cartTotal
      }
    });
  }

  cartRemove(product, cartTotal) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.CART_REMOVE,
      `Sepetten çıkarıldı: ${product.name} - ${product.price} TL`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: product.id,
      status: 'warning',
      details: {
        product_id: product.id,
        product_name: product.name,
        barcode: product.barcode,
        quantity: product.quantity,
        price: product.price,
        cart_total: cartTotal
      }
    });
  }

  cartClear(items, totalAmount) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.CART_CLEAR,
      `SEPETİ TEMİZLEDİ: ${items.length} ürün - Toplam: ${totalAmount.toFixed(2)} TL`, {
      status: 'warning',
      details: {
        items_count: items.length,
        total_amount: totalAmount,
        items: items.map(i => ({
          id: i.id,
          name: i.name,
          barcode: i.barcode,
          quantity: i.quantity,
          price: i.price
        }))
      }
    });
  }

  cartQuantityChange(product, oldQty, newQty) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.CART_QUANTITY_CHANGE,
      `Miktar değiştirildi: ${product.name} - ${oldQty} → ${newQty}`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: product.id,
      status: 'info',
      details: {
        product_id: product.id,
        product_name: product.name,
        old_quantity: oldQty,
        new_quantity: newQty,
        price: product.price
      }
    });
  }

  cartPriceEdit(product, oldPrice, newPrice) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.CART_PRICE_EDIT,
      `SEPETTE FİYAT DEĞİŞTİRİLDİ: ${product.name} - ${oldPrice} TL → ${newPrice} TL`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: product.id,
      status: 'warning',
      details: {
        product_id: product.id,
        product_name: product.name,
        barcode: product.barcode,
        old_price: oldPrice,
        new_price: newPrice,
        difference: newPrice - oldPrice
      }
    });
  }

  paymentStart(paymentMethod, amount, cart) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.PAYMENT_START,
      `Ödeme başlatıldı: ${paymentMethod} - ${amount.toFixed(2)} TL`, {
      status: 'info',
      details: {
        payment_method: paymentMethod,
        amount,
        items_count: cart.length,
        items: cart.map(i => ({ name: i.name, qty: i.quantity, price: i.price }))
      }
    });
  }

  paymentCancel(paymentMethod, amount, reason) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.PAYMENT_CANCEL,
      `ÖDEME İPTAL EDİLDİ: ${paymentMethod} - ${amount.toFixed(2)} TL`, {
      status: 'warning',
      details: {
        payment_method: paymentMethod,
        amount,
        reason
      }
    });
  }

  customerSelect(customer) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.CUSTOMER_SELECT,
      `Müşteri seçildi: ${customer.name}`, {
      entity_type: ENTITY_TYPES.CUSTOMER,
      entity_id: customer.id,
      status: 'info',
      details: {
        customer_id: customer.id,
        customer_name: customer.name,
        customer_phone: customer.phone
      }
    });
  }

  customerRemove(customer) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.CUSTOMER_REMOVE,
      `Müşteri kaldırıldı: ${customer.name}`, {
      entity_type: ENTITY_TYPES.CUSTOMER,
      entity_id: customer.id,
      status: 'info',
      details: {
        customer_id: customer.id,
        customer_name: customer.name
      }
    });
  }

  staffSelect(staff) {
    const staffNames = Array.isArray(staff) ? staff.map(s => s.name).join(', ') : staff.name;
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.STAFF_SELECT,
      `Satış sorumlusu seçildi: ${staffNames}`, {
      status: 'info',
      details: {
        staff: Array.isArray(staff) ? staff.map(s => ({ id: s.id, name: s.name })) : { id: staff.id, name: staff.name }
      }
    });
  }

  saleEdit(saleId, changes) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.SALE_EDIT,
      `SATIŞ DÜZENLENDİ: #${saleId}`, {
      entity_type: ENTITY_TYPES.SALE,
      entity_id: saleId,
      status: 'warning',
      details: changes
    });
  }

  saleDelete(saleId, saleDetails) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.SALE_DELETE,
      `SATIŞ SİLİNDİ: #${saleId} - ${saleDetails.total} TL`, {
      entity_type: ENTITY_TYPES.SALE,
      entity_id: saleId,
      status: 'error',
      details: saleDetails
    });
  }

  giftCardApply(giftCard, discount) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.GIFT_CARD_APPLY,
      `Bakiye uygulandı: ${giftCard.code} - ${discount} TL`, {
      entity_type: ENTITY_TYPES.GIFT_CARD,
      entity_id: giftCard.id,
      status: 'success',
      details: {
        code: giftCard.code,
        discount,
        remaining: giftCard.remaining_balance
      }
    });
  }

  giftCardRemove(giftCard) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.GIFT_CARD_REMOVE,
      `Bakiye kaldırıldı: ${giftCard.code}`, {
      entity_type: ENTITY_TYPES.GIFT_CARD,
      entity_id: giftCard.id,
      status: 'info'
    });
  }

  scrapDiscountApply(amount, scrapInfo) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.SCRAP_DISCOUNT_APPLY,
      `Hurda indirimi uygulandı: ${amount} TL`, {
      status: 'info',
      details: {
        discount_amount: amount,
        scrap_info: scrapInfo
      }
    });
  }

  partialPayment(method, amount, totalPaid, remaining) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.PARTIAL_PAYMENT,
      `Kısmi ödeme: ${method} - ${amount.toFixed(2)} TL`, {
      status: 'info',
      details: {
        payment_method: method,
        amount,
        total_paid: totalPaid,
        remaining
      }
    });
  }

  debtSale(customerId, customerName, amount) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.DEBT_SALE,
      `AÇIK HESAP SATIŞI: ${customerName} - ${amount.toFixed(2)} TL`, {
      entity_type: ENTITY_TYPES.CUSTOMER,
      entity_id: customerId,
      status: 'warning',
      details: {
        customer_id: customerId,
        customer_name: customerName,
        debt_amount: amount
      }
    });
  }

  holdSale(items, totalAmount) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.HOLD_SALE,
      `Satış bekletildi: ${items.length} ürün - ${totalAmount.toFixed(2)} TL`, {
      status: 'info',
      details: {
        items_count: items.length,
        total_amount: totalAmount,
        items: items.map(i => ({ name: i.name, qty: i.quantity, price: i.price }))
      }
    });
  }

  resumeSale(heldSale) {
    this.log(LOG_MODULES.SALES, LOG_ACTIONS.RESUME_SALE,
      `Bekleyen satış devam ettirildi: ${heldSale.items?.length || 0} ürün`, {
      status: 'info',
      details: {
        held_sale_id: heldSale.id,
        items_count: heldSale.items?.length || 0
      }
    });
  }

  // Ürün logları
  productCreate(product) {
    this.log(LOG_MODULES.PRODUCTS, LOG_ACTIONS.CREATE,
      `Ürün eklendi: ${product.name}`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: product.id,
      status: 'success',
      details: { barcode: product.barcode, price: product.sell_price }
    });
  }

  productUpdate(product, changes) {
    this.log(LOG_MODULES.PRODUCTS, LOG_ACTIONS.UPDATE,
      `Ürün güncellendi: ${product.name}`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: product.id,
      status: 'info',
      details: changes
    });
  }

  productDelete(productId, productName) {
    this.log(LOG_MODULES.PRODUCTS, LOG_ACTIONS.DELETE,
      `Ürün silindi: ${productName}`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: productId,
      status: 'warning'
    });
  }

  stockAdjust(productId, productName, oldStock, newStock, reason) {
    this.log(LOG_MODULES.PRODUCTS, LOG_ACTIONS.STOCK_ADJUST,
      `Stok güncellendi: ${productName} - ${oldStock} → ${newStock}`, {
      entity_type: ENTITY_TYPES.PRODUCT,
      entity_id: productId,
      status: 'info',
      details: { oldStock, newStock, change: newStock - oldStock, reason }
    });
  }

  // Müşteri logları
  customerCreate(customer) {
    this.log(LOG_MODULES.CUSTOMERS, LOG_ACTIONS.CREATE,
      `Müşteri eklendi: ${customer.name}`, {
      entity_type: ENTITY_TYPES.CUSTOMER,
      entity_id: customer.id,
      status: 'success',
      details: { phone: customer.phone }
    });
  }

  customerUpdate(customer) {
    this.log(LOG_MODULES.CUSTOMERS, LOG_ACTIONS.UPDATE,
      `Müşteri güncellendi: ${customer.name}`, {
      entity_type: ENTITY_TYPES.CUSTOMER,
      entity_id: customer.id,
      status: 'info'
    });
  }

  debtAdd(customerId, customerName, amount, type) {
    this.log(LOG_MODULES.DEBTS, LOG_ACTIONS.DEBT_ADD,
      `Borç eklendi: ${customerName} - ${amount} ${type}`, {
      entity_type: ENTITY_TYPES.CUSTOMER,
      entity_id: customerId,
      status: 'info',
      details: { amount, type }
    });
  }

  debtPayment(customerId, customerName, amount) {
    this.log(LOG_MODULES.DEBTS, LOG_ACTIONS.DEBT_PAYMENT,
      `Borç tahsilatı: ${customerName} - ${amount} TL`, {
      entity_type: ENTITY_TYPES.CUSTOMER,
      entity_id: customerId,
      status: 'success',
      details: { amount }
    });
  }

  // Tamir logları
  repairCreate(repair) {
    this.log(LOG_MODULES.REPAIRS, LOG_ACTIONS.CREATE,
      `Tamir kaydı oluşturuldu: ${repair.code}`, {
      entity_type: ENTITY_TYPES.REPAIR,
      entity_id: repair.id,
      status: 'success',
      details: { customer: repair.customer_name, product: repair.product_name }
    });
  }

  repairStatusChange(repairId, code, oldStatus, newStatus) {
    this.log(LOG_MODULES.REPAIRS, LOG_ACTIONS.REPAIR_STATUS_CHANGE,
      `Tamir durumu değişti: ${code} - ${oldStatus} → ${newStatus}`, {
      entity_type: ENTITY_TYPES.REPAIR,
      entity_id: repairId,
      status: 'info',
      details: { oldStatus, newStatus }
    });
  }

  // Kampanya logları
  campaignCreate(campaign) {
    this.log(LOG_MODULES.CAMPAIGNS, LOG_ACTIONS.CREATE,
      `Kampanya oluşturuldu: ${campaign.name}`, {
      entity_type: ENTITY_TYPES.CAMPAIGN,
      entity_id: campaign.id,
      status: 'success'
    });
  }

  campaignApply(campaignId, campaignName, discount) {
    this.log(LOG_MODULES.CAMPAIGNS, LOG_ACTIONS.APPLY_CAMPAIGN,
      `Kampanya uygulandı: ${campaignName} - ${discount} TL indirim`, {
      entity_type: ENTITY_TYPES.CAMPAIGN,
      entity_id: campaignId,
      status: 'success',
      details: { discount }
    });
  }

  // Personel logları
  employeeCreate(employee) {
    this.log(LOG_MODULES.PERSONNEL, LOG_ACTIONS.CREATE,
      `Personel eklendi: ${employee.name}`, {
      entity_type: ENTITY_TYPES.EMPLOYEE,
      entity_id: employee.id,
      status: 'success'
    });
  }

  // Hurda logları
  scrapPurchase(scrap) {
    this.log(LOG_MODULES.SCRAP, LOG_ACTIONS.CREATE,
      `Hurda alımı: ${scrap.weight}gr ${scrap.metal_type} - ${scrap.total_price} TL`, {
      entity_type: ENTITY_TYPES.SCRAP,
      entity_id: scrap.id,
      status: 'success',
      details: { weight: scrap.weight, purity: scrap.purity, price: scrap.total_price }
    });
  }

  // Masraf logları
  expenseCreate(expense) {
    this.log(LOG_MODULES.EXPENSES, LOG_ACTIONS.CREATE,
      `Masraf eklendi: ${expense.description} - ${expense.amount} TL`, {
      entity_type: ENTITY_TYPES.EXPENSE,
      entity_id: expense.id,
      status: 'info',
      details: { category: expense.category, amount: expense.amount }
    });
  }

  // Sayım logları
  inventoryStart(sessionId) {
    this.log(LOG_MODULES.INVENTORY, LOG_ACTIONS.INVENTORY_COUNT,
      'Sayım başlatıldı', {
      entity_id: sessionId,
      status: 'info'
    });
  }

  inventoryComplete(sessionId, stats) {
    this.log(LOG_MODULES.INVENTORY, LOG_ACTIONS.INVENTORY_COUNT,
      'Sayım tamamlandı', {
      entity_id: sessionId,
      status: 'success',
      details: stats
    });
  }

  // Yedekleme logları
  backupCreate(filename) {
    this.log(LOG_MODULES.SETTINGS, LOG_ACTIONS.BACKUP,
      `Yedek oluşturuldu: ${filename}`, {
      status: 'success',
      details: { filename }
    });
  }

  backupRestore(filename) {
    this.log(LOG_MODULES.SETTINGS, LOG_ACTIONS.RESTORE,
      `Yedek geri yüklendi: ${filename}`, {
      status: 'warning',
      details: { filename }
    });
  }

  // Kur logları
  rateUpdate(currency, rate) {
    this.log(LOG_MODULES.RATES, LOG_ACTIONS.UPDATE,
      `Kur güncellendi: ${currency} = ${rate} TL`, {
      status: 'info',
      details: { currency, rate }
    });
  }

  // Genel view/search logları
  pageView(module, pageName) {
    this.log(module, LOG_ACTIONS.VIEW, `Sayfa görüntülendi: ${pageName}`, {
      status: 'info'
    });
  }

  search(module, query, resultsCount) {
    this.log(module, LOG_ACTIONS.SEARCH, `Arama: "${query}" - ${resultsCount} sonuç`, {
      status: 'info',
      details: { query, resultsCount }
    });
  }

  export(module, format, count) {
    this.log(module, LOG_ACTIONS.EXPORT, `Dışa aktarma: ${count} kayıt (${format})`, {
      status: 'success',
      details: { format, count }
    });
  }
}

// Singleton instance
const logService = new LogService();
export default logService;
